import React,{useState,useEffect} from 'react'
import EcxSidebar from './components/EcxSidebar'
import EcxHeader from './components/EcxHeader'
import { Outlet } from 'react-router-dom'
import { useEyeconxStore } from '../../store/eyeconxStore'
import clinicService from '../../services/clinic.service'
import Loading from '../common/Loading'

function MainLayout() {
  const user = useEyeconxStore(state=>state.user)
  const userInfo = useEyeconxStore(state=>state.userInfo)
  const setUserInfo = useEyeconxStore(state=>state.setUserInfo)
 
  useEffect(()=>{
   
    if(userInfo === null){
      getUserInfo()
    }
  },[])

  const getUserInfo = ()=>{
    clinicService.getUserInfo(user.clinicId,user.ID)
    .then(res=>{
      setUserInfo(res.data)
      console.log(res.data)
    })
    .catch(err=>{
      console.log(err)
    })
 }
  return (
    <>
    <div style={{
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          minHeight: "100vh",
          backgroundColor: "#fcfcfc",
         
        }}>
            {/* Sidebar - in its own column that will stretch with content */}
            <div style={{
             
              height: "100%"
            }}>
              <EcxSidebar/>
            </div>
  
            {/* Main content area */}
            <div style={{
              display: "flex",
              flexDirection: "column"
            }}>
              {/* Header */}
              <div className="flex-center" style={{height: "70px"}}>
                <EcxHeader/>
              </div>
              
              {/* Content area */}
              <div className="app-content">
                <div className="app-container container-xxl">
                  {<Outlet/>}
                </div>
              </div>
            </div>
          </div>

    {/*
    <div className='d-flex flex-row' style={{height:"100vh",alignItems:"stretch",backgroundColor:"#fcfcfc",border:"2px solid red"}}>

      <div className="d-flex flex-column" style={{flex:"0 0 auto",height:"100%",overflow:"auto",border:"2px solid blue"}}>
            <EcxSidebar/>
      </div>
      <div className="d-flex flex-column flex-row-fluid" style={{height:"100%"}}>
           <div className="d-flex flex-column-auto h-70px flex-center">
                <EcxHeader/>
            </div>
          <div className="app-content flex-column-fluid">

          
          <div className="app-container container-xxl">
            {<Outlet/>}
          </div>
          </div>
      </div>
    </div>
    */}
  
  {/* <div className="d-flex flex-row" style={{height:"100%",backgroundColor:"#fcfcfc"}}>
        <div className="d-flex flex-column flex-row-auto" style={{height:"100%"}}>
            <EcxSidebar/>
        </div>
        <div className="d-flex flex-column flex-row-fluid">
            <div className="d-flex flex-column-auto h-70px flex-center">
                <EcxHeader/>
            </div>
            <div className="d-flex flex-row flex-column-fluid">
               <div className="d-flex flex-row-fluid">
                
                 {<Outlet/>}
               
               </div>
                
               
            </div>
        </div>
  </div>*/}
    </>
  )
}

export default MainLayout